module.exports = __webpack_public_path__ + "img/star4.a82bb5a9.png";